import {makeAutoObservable} from 'mobx';
import {KeyAc, categories} from './constants';
import {newCopiaStore} from '../../modules/copia/newCopia.store';
import {CategoryKey} from '../../modules/copia/copia.type';
import FilterController from '../../modules/copia/Controllers';
import {globalStore} from '../../global.store';
import {apiServiceDepartments} from '../../services/apiService';
import SearchRoom from '../searchRoom';
import {searchStore} from '../searchRoom/searchRoom.store';
import CONSTRUCTORS from "../../data/constructors/constructors";

class FilterStore {
    isLoading = true;

    category: CategoryKey = 'apartments';

    filters: any = {};

    activeFilters: any = {};

    onFilter: any = null;

    querys: any = {};

    queryParams: any = {};

    isDataLoading = true;

    setSearchParams: Function;

    constructor() {
        makeAutoObservable(this);
    }

    setFilters = (data: any) => {
        this.filters = data;
    };

    setCategory = (title: CategoryKey) => {
        this.category = title;
    };

    setIsLoading = (state: boolean) => {
        this.isLoading = state;
    };

    openCategory = (category: string) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                selected: !this.filters[category].selected,
            },
        };
    };

    selectType = ({query, category}: any) => {
        /// //////////////////////Ashxatuma
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category].childs.map((child: any) => {
                    if (child.id === query) {
                        child.selected = !child.selected;
                    }
                    if (child.isSingle && child.id !== query) {
                        child.selected = false;
                    }
                    // else {
                    //   child.selected = false
                    // }
                    return child;
                }),
            },
        };
        this.requestData();
    };

    openCategoryChild = (category: any, child: any) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category].childs.map((item: any) => {
                    if (item.query === child.query) {
                        item.selected = !item.selected;
                    } else {
                        item.selected = false;
                    }
                    return item;
                }),
            },
        };
    };

    openCategoryNestedChild = (category: any, index: any) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category].childs.map((item: any, i: number) => ({
                    ...item,
                    selected: i === index ? !item.selected : false,
                })),
            },
        };
    };

    selectCategoryChildValue = (category: any, child: any, query: any) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category]?.childs.map((item: any) =>
                    query === item.query
                        ? {
                            ...item,
                            selected: false,
                            childs: [...child],
                        }
                        : item,
                ),
            },
        };
        this.requestData();
    };

    selectCategoryNestedChildValue = (
        category: any,
        data: any,
        index: number,
    ) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category]?.childs.map((item: any, i: number) => {
                    if (i === index) {
                        return {
                            ...item,
                            childs: data,
                        };
                    }
                    return item;
                }),
            },
        };
        this.requestData();
    };

    selectCategoryPriceValue = (category: any, data: any) => {
        this.filters = {
            ...this.filters,
            [category]: {
                ...this.filters[category],
                childs: this.filters[category]?.childs.map((item: any, i: number) => ({
                    ...item,
                    ...data[i],
                })),
            },
        };
        this.requestData();
    };

    resetFilters = () => {
        this.filters = Object.keys(this.filters).reduce(
            (acc, query: any) => ({
                ...acc,
                [query]: {
                    ...this.filters[query],
                    childs: this.filters[query]?.childs.map((item: any) => {
                        const clearId = item.name === 'From' || item.name === 'To';
                        return {
                            ...item,
                            id: clearId ? undefined : item.id,
                            selected: false,
                            childs: item?.childs?.map((item: any) => ({
                                ...item,
                                selected: false,
                            })),
                        };
                    }),
                },
            }),
            {},
        );
    };

    clearData = () => {
        // this.resetFilters()
        this.queryParams = {};
    };

    getQuerys = (incomingQueries: any = {}) => {
        const res = Object.keys(this.filters).reduce(
            (acc: any, key: any) => ({
                ...acc,
                ...this.filters[key].getQueries(incomingQueries),
            }),
            {},
        );
        if (newCopiaStore.searchValue) {
            res.search = newCopiaStore.searchValue;
        }
        return res;
    };

    requestData = async (changeParams = true, incomingQueries: any = {}) => {
        const queries = this.getQuerys(incomingQueries);
        this.setIsLoading(true);

        try {
            const cards = await newCopiaStore.categoryMap[this.category](queries);
            changeParams &&
            this.setSearchParams(
                () => {
                    return {
                        ...queries,
                        ...incomingQueries,
                    };
                },
                {replace: true},
            );
            let data = cards.data.items || cards.data.result || [];

            if (this.category === 'constructors') {
                data = CONSTRUCTORS;
            }

            newCopiaStore.setCards(data);
            searchStore.setRooms(data)
        } catch (error) {
            globalStore.navigation('copia/apartments');
        } finally {
            this.setIsLoading(false);
        }
    };

    onOpenChild = (opt: any) => {
        this.filters = {
            ...this.filters,
            [opt.category]: this.filters[opt.category].map((child: any) => {
                const value = child.id === opt.query;
                return {
                    ...child,
                    selected: value ? !child.selected : child.selected,
                };
            }),
        };
    };

    buildFilterQuery = async (
        category: CategoryKey,
        fetchData: any,
        searchParams: any,
        queryParams: any,
    ) => {
        this.queryParams = queryParams;
        this.setSearchParams = searchParams;
        this.category = category || this.category;
        const data = await fetchData(category || this.category);

        this.filters = data;

        this.requestData(false);
    };

    getCategoryFilters = async (category: CategoryKey = 'apartments') => {
        const {queries = []} = this.getFilterOptions(category);

        const requestArr: Promise<any>[] = queries.map((key: any) => {
            const url = `${category}/${key}`;
            return apiServiceDepartments.getFilters(url);
        });
        this.isDataLoading = true;
        const responses = await Promise.all(requestArr);

        this.isDataLoading = false;

        const categoryFilters = responses
            .map((item: any) => item?.data?.result)
            .reduce((acc, item, i: any) => {
                if (item === undefined) return acc;
                const filters = FilterController.transformData(item, this.queryParams);
                return {
                    ...acc,
                    ...filters,
                };
            }, {});
        return categoryFilters;
    };

    getFilterOptions = (key: CategoryKey) => {
        const options: {
            [key: string]: {
                queries: KeyAc[];
            };
        } = {
            [categories.apartments]: {
                queries: ['filters'],
            },
            [categories.restaurants]: {
                queries: ['filters'],
            },
            [categories.hotels]: {
                queries: ['filters'],
            },
            [categories.constructors]: {
                queries: ['filters'],
            },
        };
        return options[key] || {queries: []};
    };

    onReset = () => {
        this.resetFilters();
        this.requestData();
    };
}

const filterStore = new FilterStore();
export default filterStore;
